// removed by extract-text-webpack-plugin
module.exports = {"root":"bab7d7ec","backdrop":"_4b56932e"};


//////////////////
// WEBPACK FOOTER
// ./src/components/common/ImageViewer/index.styl
// module id = 5206
// module chunks = 39